import {
  createContext,
  useContext,
  useMemo,
  useState,
  useCallback,
} from 'react';

interface ListHoverValue {
  isHover: boolean;
  cardId: number | null;
}

interface Context {
  handleMouseEnterInTitle: (cardId: number) => void;
  handleMouseLeaveInTitle: () => void;
  hoverEffectImage: ListHoverValue;
  hoverEffectTitle: ListHoverValue;
  setHoverEffectImage: React.Dispatch<React.SetStateAction<ListHoverValue>>;
  setHoverEffectTitle: React.Dispatch<React.SetStateAction<ListHoverValue>>;
}

const ListContext = createContext({} as Context);

export const useListContext = () => useContext(ListContext);

export const ListProvider = ({ children }) => {
  const [hoverEffectImage, setHoverEffectImage] = useState<ListHoverValue>({
    isHover: false,
    cardId: null,
  });

  const [hoverEffectTitle, setHoverEffectTitle] = useState<ListHoverValue>({
    isHover: false,
    cardId: null,
  });

  const handleMouseEnterInTitle = useCallback(
    (cardId: number) => setHoverEffectTitle({ cardId, isHover: true }),
    [],
  );

  const handleMouseLeaveInTitle = useCallback(
    () => setHoverEffectTitle({ cardId: null, isHover: false }),
    [],
  );

  const providerState = useMemo(
    () => ({
      hoverEffectImage,
      setHoverEffectImage,
      hoverEffectTitle,
      setHoverEffectTitle,
      handleMouseEnterInTitle,
      handleMouseLeaveInTitle,
    }),
    [
      hoverEffectImage,
      hoverEffectTitle,
      handleMouseEnterInTitle,
      handleMouseLeaveInTitle,
    ],
  );

  return (
    <ListContext.Provider value={providerState}>
      {children}
    </ListContext.Provider>
  );
};

export default ListContext;
